import { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import serviceBanner from "../../assets/mobile-banners/Gem_Web_Banners_TV_Buy.webp";
import CustomSlider from "../../components/CustomSlider";
import Footer from "../../components/footer/Footer";
import Header from "../../components/navbar/Header";
import EnquiryModal from "./EnquiryModal";
const servicemobileSlides = [
  {
    img: serviceBanner,
    alt: "Offer 1",
  },
];
const carData = [
  {
    id: 1,
    img: require("../../assets/thumbnails/alto-k10.webp"),
    year: "2010",
    fuel: "Petrol",
    km: "64871",
    name: "Maruti Alto LXI",
    price: "195000.00*",
  },
  {
    id: 2,
    img: require("../../assets/thumbnails/brezza.webp"),
    year: "2014",
    fuel: "Petrol",
    km: "52340",
    name: "Maruti Wagon R VXI",
    price: "325000.00*",
  },
  {
    id: 3,
    img: require("../../assets/thumbnails/ertiga.webp"),
    year: "2016",
    fuel: "Diesel",
    km: "68900",
    name: "Maruti Swift VDI",
    price: "425000.00*",
  },
  {
    id: 4,
    img: require("../../assets/thumbnails/alto-k10.webp"),
    year: "2010",
    fuel: "Petrol",
    km: "64871",
    name: "Maruti Alto LXI",
    price: "195000.00*",
  },
  {
    id: 5,
    img: require("../../assets/thumbnails/brezza.webp"),
    year: "2014",
    fuel: "Petrol",
    km: "52340",
    name: "Maruti Wagon R VXI",
    price: "325000.00*",
  },
  {
    id: 6,
    img: require("../../assets/thumbnails/ertiga.webp"),
    year: "2016",
    fuel: "Diesel",
    km: "68900",
    name: "Maruti Swift VDI",
    price: "425000.00*",
  },
];

export default function BuyCar() {
  const [cars] = useState(carData);
  const [search, setSearch] = useState("");
  const [fuel, setFuel] = useState("");
  const [year, setYear] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);

  /* ---------------- FILTER LOGIC ---------------- */
  const filteredCars = cars.filter((car) => {
    return (
      car.name.toLowerCase().includes(search.toLowerCase()) &&
      (fuel ? car.fuel === fuel : true) &&
      (year ? car.year === year : true)
    );
  });

  /* ---------------- ENQUIRE HANDLER ---------------- */
  const handleEnquire = (car) => {
    setSelectedCar(car);
    setOpenModal(true);
  };

  return (
    <>
      <Helmet>
        <title>
          Maruti Suzuki True Value in Hyderabad | Buy & Sell Certified Used Cars
        </title>
        <meta
          name="description"
          content="Maruti Suzuki True Value Showroom in Hyderabad. Buy & Sell used cars in Hyderabad."
        />
      </Helmet>

      <Header />

      <div className="hidden md:block">
        <img
          src={require("../../assets/banners-3/Banners_Buy-Your-Car.jpg")}
          className="w-full lg:h-[550px] object-cover"
          loading="lazy"
          alt="truevalue banner"
        />
      </div>
      <CustomSlider
        slides={servicemobileSlides}
        effect="fade"
        className="sm:hidden"
        imgClass="lg:mt-16"
      />
      <div className="px-4 shadow sm:px-0">
        <p className="container py-4 mx-auto">
          <Link to="/">Home</Link> / Used Cars
        </p>
      </div>
      <div className="max-w-6xl px-4 py-10 mx-auto font-sans">
        {/* ---------------- SUBTITLE ---------------- */}
        <p className="mb-10 text-xl text-center text-black ">
          A trusted destination for buying pre-owned cars
        </p>
        {/* ---------------- SEARCH FILTERS ---------------- */}
        <div className="grid grid-cols-1 gap-4 mb-10 sm:grid-cols-3">
          <input
            type="text"
            placeholder="Search Model"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="px-3 py-2 text-sm border rounded"
          />

          <select
            value={fuel}
            onChange={(e) => setFuel(e.target.value)}
            className="px-3 py-2 text-sm border rounded"
          >
            <option value="">Fuel</option>
            <option value="Petrol">Petrol</option>
            <option value="Diesel">Diesel</option>
          </select>

          <select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="px-3 py-2 text-sm border rounded"
          >
            <option value="">Year</option>
            <option value="2010">2010</option>
            <option value="2015">2015</option>
          </select>
        </div>

        {/* ---------------- CAR GRID ---------------- */}
        <div className="grid grid-cols-1 gap-10 mb-20 sm:grid-cols-2 lg:grid-cols-3">
          {filteredCars.map((car) => (
            <div
              key={car.id}
              className="bg-white rounded-[22px] shadow-[0_8px_18px_rgba(0,0,0,0.18)] p-4 text-center"
            >
              <img
                src={car.img}
                alt="car"
                className="w-full h-[210px] object-cover rounded-[18px]"
              />

              <div className="flex justify-between mt-3 text-sm">
                <span>{car.year}</span>
                <span>{car.fuel}</span>
                <span>{car.km}</span>
              </div>

              <div className="flex justify-between mt-3 text-sm font-semibold">
                <span>{car.name}</span>
                <span>{car.price}</span>
              </div>

              <button
                onClick={() => handleEnquire(car)}
                className="w-40 mt-4 py-2 rounded-full text-white text-sm bg-[#d43c2c] hover:bg-[#2E2583]"
              >
                Enquire
              </button>
            </div>
          ))}
        </div>

        {/* ---------------- BOTTOM FORM ---------------- */}
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-[#d43c2c] mb-1 ">
            Could not find right model?
          </h2>
          <p className="mb-8 text-sm">
            fill out the form our executive get back to you!
          </p>

          <div className="grid max-w-3xl grid-cols-1 gap-8 mx-auto md:grid-cols-2">
            {["Name *", "Phone Number*", "Email ID*", "Your Requirements"].map(
              (label, i) => (
                <div key={i} className="text-left">
                  <label className="text-sm">{label}</label>
                  <input className="w-full py-2 border-b border-gray-400 outline-none" />
                </div>
              ),
            )}
          </div>

          <p className="text-[11px] text-left max-w-3xl mx-auto mt-6">
            Disclaimer: I agree that by clicking the "Submit" button below, I am
            explicitly soliciting a call/message from Gem Motors Pvt. Ltd.
          </p>

          <button className="mt-6 hover:bg-[#253E72] bg-[#d43c2c] text-white px-10 py-2 rounded-full text-sm">
            Submit
          </button>
        </div>

        {/* ---------------- ENQUIRE MODAL ---------------- */}
        {openModal && (
          <EnquiryModal car={selectedCar} onClose={() => setOpenModal(false)} />
        )}
      </div>
      <Footer />
    </>
  );
}
